import { GenericTransactionTable } from "../../components/generic/GenericTransactionTable";
import React, { useEffect } from "react";
import "../../stylesheets/components/Reports/PandLReports/TransactionTable.scss";
import { useSelector } from "react-redux";
import { TransactionType, } from "@domains/aggregates/interfaces/Reports/iPNLTransactionReport";
import moment from "moment";
import PNLReportsdi from "@frameworks/web/components/Reports/PNLReports/di/servicelocator";
import Common_Shimmer from "@frameworks/web/components/features/Markets/Equity/Equityshimmer/common_shimmer";
import { ReportName } from "@domains/aggregates/interfaces/Reports/iHoldingReport";
import { getDateInFormat, previousDay } from "@domains/utils/reportDates";
import _ from "underscore";
export const TransactionTable = React.memo((props) => {
    const { data: txnList, showTransactionShimmer: showTransactionShimmer } = useSelector((state) => state.pnltranasactionReport);
    useEffect(() => {
        if (props.ReportName === ReportName.HOLDINGS) {
            let payload = {
                scripIdentifier: props.item.scripIdentifier,
                date: getDateInFormat(previousDay, "YYYY-MM-DD"),
            };
            if (!props.isMyaccount)
                payload.accountIds = props.accCode;
            PNLReportsdi.pnlTransactionReport.holdingTransactionDetails(payload);
        }
        else {
            const payload = {
                fromDate: moment(props.fromDate).format("yyyy-MM-DD"),
                toDate: moment(props.endDate).format("yyyy-MM-DD"),
                assetType: props.assetType,
                scripIdentifier: props.item.scripIdentifier,
                transactionType: props.transactionType,
            };
            if (!props.isMyaccount)
                payload.accountIds = props.accCode;
            PNLReportsdi.pnlTransactionReport.getPNLTransactionsReportData(payload);
            if (props.transactionType === TransactionType.REALISED)
                PNLReportsdi.pnlTransactionReport.getRealisedUnderstandingSectionData();
            else if (props.transactionType === TransactionType.UNREALISED)
                PNLReportsdi.pnlTransactionReport.getUnrealisedUnderstandingSectionData();
        }
    }, []);
    return (React.createElement(React.Fragment, null, showTransactionShimmer ? (React.createElement(Common_Shimmer, { number: 3, className: "p-2" })) : (React.createElement(React.Fragment, null,
        React.createElement(GenericTransactionTable, { txnList: txnList.pnLTransactionDetails, editTransaction: props.editTransaction, parentClassName: "L2-txn-tbl", isMyaccount: props.isMyaccount })))));
}, (prevProps, nextProps) => _.isEqual(prevProps, nextProps));
